import React from 'react'
import Link from 'components/Link'
import { ImportantLink } from 'components/Docs/ImportantLink'
import { prepareData } from 'utils/googleData'


const Grid = ({ title, description, links }) => (
    <div className="bg-gray-accent-light px-6 py-4 dark:bg-gray-accent-dark lg:rounded">
      <div className="mb-3">
        <h4 className="mb-0 font-bold">{title}</h4>
        <p className="text-sm text-gray">{description}</p>
      </div>
      <ul className="m-0 grid w-full list-none space-y-1 p-0 sm:grid-cols-2 xl:grid-cols-1">
        {links.map((link, index) => {
          const Icon = link.Icon;
          return (
          <li key={index} className="flex-grow">
            <ImportantLink to={link.url} title={link.label} badge={link.badge}>
            {Icon && (
                                      <Icon
                                          key={link.label}
                                          className={`icon-class `}
                                      />
                                  )}
              {link.badge && (
                <div className="flex h-5 w-5 items-center justify-center rounded bg-red text-xs text-white opacity-60">
                  <span>{index + 1}</span>
                </div>
              )}
            </ImportantLink>
          </li>
        )})}
      </ul>
    </div>
  );

  export function QuickLinks(props) {
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, items,gatsbyImageSrc } = prepareData({
        props,
    })
    const sortedItems = React.useMemo(() => {
        return items.map(item => {
          if (item.title === "Getting started") {
            // Sort the links of the "Getting started" section if needed
            const sortedLinks = item.links.sort((a, b) => {
              // Implement sorting logic here, possibly based on a predefined order
              return a.label.localeCompare(b.label);
            });

            return { ...item, links: sortedLinks };
          }
          return item;
        });
      }, [items]);

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    return (
    <section className="space-y-8">
      <div className="text-center">
        <h2 className="mb-1 inline-block w-full font-bold">{title}</h2>
      </div>
      <div className="grid grid-cols-1 gap-x-4 overflow-hidden rounded xl:grid-cols-3 xl:rounded-none">
        {items.map((grid, index) => (
          <Grid key={index} title={grid.title} description={grid.description} links={grid.links} />
        ))}
      </div>
    </section>
  )};
  export default  QuickLinks
